<div class="contact-container" [formGroup]="contactItemForm">
  <mat-divider></mat-divider>
  <div class="contact-layout">

    <!-- Radio: mark as primary (legacy with-gap / Project Details amber) -->
    <div class="contact-radio">
      <input class="with-gap" type="radio" name="primaryc"
        [value]="contactItemForm.controls.id.value"
        [checked]="isDefaultContact()"
        [attr.disabled]="_authService.readOnly ? '' : null"
        (change)="onItemSelectionChange(contactItemForm)"
        id="{{ 'primaryc' + current }}">
      <label attr.for="{{ 'primaryc' + current }}"
        matTooltip="mark as primary company contact"
        matTooltipPosition="below"></label>
    </div>

    <!-- Form fields -->
    <div class="contact-fields">

      <!-- Name / Title -->
      <div class="fields-row two-cols">
        <mat-form-field appearance="fill">
          <mat-label>Contact Name</mat-label>
          <input matInput formControlName="name" type="text">
          <mat-error *ngIf="displayMessage.name">{{ displayMessage.name }}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Contact Title</mat-label>
          <input matInput formControlName="contactTitle" type="text">
          <mat-error *ngIf="displayMessage.contactTitle">{{ displayMessage.contactTitle }}</mat-error>
        </mat-form-field>
      </div>

      <!-- Address -->
      <div class="fields-row two-cols">
        <mat-form-field appearance="fill">
          <mat-label>Address</mat-label>
          <input matInput formControlName="address" type="text">
          <mat-error *ngIf="displayMessage.address">{{ displayMessage.address }}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Address 2</mat-label>
          <input matInput formControlName="address2" type="text">
          <mat-error *ngIf="displayMessage.address2">{{ displayMessage.address2 }}</mat-error>
        </mat-form-field>
      </div>

      <!-- City / State / Zip / Country -->
      <div class="fields-row four-cols-location">
        <mat-form-field appearance="fill">
          <mat-label>City</mat-label>
          <input matInput formControlName="city" type="text">
          <mat-error *ngIf="displayMessage.city">{{ displayMessage.city }}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>State</mat-label>
          <input matInput formControlName="state" type="text">
          <mat-error *ngIf="displayMessage.state">{{ displayMessage.state }}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Zipcode</mat-label>
          <input matInput formControlName="zipCode" type="text">
          <mat-error *ngIf="displayMessage.zipCode">{{ displayMessage.zipCode }}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Country</mat-label>
          <input matInput formControlName="country" type="text">
          <mat-error *ngIf="displayMessage.country">{{ displayMessage.country }}</mat-error>
        </mat-form-field>
      </div>

      <!-- Phone numbers -->
      <div class="fields-row four-cols">
        <mat-form-field appearance="fill">
          <mat-label>Phone Number</mat-label>
          <input matInput formControlName="phoneNumber" type="tel">
          <mat-error *ngIf="displayMessage.phoneNumber">{{ displayMessage.phoneNumber }}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Cell Number</mat-label>
          <input matInput formControlName="cellNumber" type="tel">
          <mat-error *ngIf="displayMessage.cellNumber">{{ displayMessage.cellNumber }}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Office Phone Number</mat-label>
          <input matInput formControlName="phoneNumber2" type="tel">
          <mat-error *ngIf="displayMessage.phoneNumber2">{{ displayMessage.phoneNumber2 }}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Other Phone Number</mat-label>
          <input matInput formControlName="phoneNumber3" type="tel">
          <mat-error *ngIf="displayMessage.phoneNumber3">{{ displayMessage.phoneNumber3 }}</mat-error>
        </mat-form-field>
      </div>

      <!-- Fax / Email -->
      <div class="fields-row two-cols">
        <mat-form-field appearance="fill">
          <mat-label>Fax Number</mat-label>
          <input matInput formControlName="faxNumber" type="tel">
          <mat-error *ngIf="displayMessage.faxNumber">{{ displayMessage.faxNumber }}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" type="email">
          <mat-error *ngIf="displayMessage.email">{{ displayMessage.email }}</mat-error>
        </mat-form-field>
      </div>

      <!-- Notes -->
      <div class="fields-row full-width">
        <mat-form-field appearance="fill">
          <mat-label>Contact Notes</mat-label>
          <textarea matInput formControlName="notes" maxlength="255"></textarea>
          <mat-error *ngIf="displayMessage.notes">{{ displayMessage.notes }}</mat-error>
        </mat-form-field>
      </div>

    </div>

    <!-- Add / Remove buttons -->
    <div class="contact-actions" *ngIf="!_authService.readOnly">
      <div *ngIf="(current + 1 === 1 || count === 0); else elseBlock">
        <button mat-icon-button
                [disabled]="!contactItemForm.valid"
                (click)="addContactItem()"
                matTooltip="add another contact"
                matTooltipPosition="below">
          <mat-icon>add</mat-icon>
        </button>
      </div>
      <ng-template #elseBlock>
        <button mat-icon-button
                (click)="removeContactItem(current)"
                matTooltip="remove contact"
                matTooltipPosition="below">
          <mat-icon>remove</mat-icon>
        </button>
      </ng-template>
    </div>

  </div>
</div>
